import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const MATERIEL_URL = `${backendUrl}/api/materiel/`;

class MaterielService {
	async getAllMateriels() {
		try {
			const response = await axios.get(MATERIEL_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getMateriel(id) {
		return axios.get(`${MATERIEL_URL}${id}/`);
	}

	createMateriel(data) {
		return axios.post(MATERIEL_URL, data).catch((error) => {
			console.error('Erreur lors de la création du materiel', error);
			throw error;
		});
	}

	updateMateriel(id, data) {
		return axios.put(`${MATERIEL_URL}${id}/`, data);
	}

	deleteMateriel(id) {
		return axios.delete(`${MATERIEL_URL}${id}/`);
	}
}

export default new MaterielService();
